// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-ItGzd";
var _3 = "slider-yOS3h";
var _4 = "inside-1ddD0";
var _5 = "inside_transition-2HvWv";
var _6 = "elementsWrapper-1qpjZ";
var _7 = "arrow-2gjje";
var _8 = "arrow_next-MpjZa";
var _9 = "hide-2brHK";
var _a = "arrow_prev-2zKw2";
var _b = "disabled-3pvsc";
export { _1 as "__esModule", _2 as "container", _3 as "slider", _4 as "inside", _5 as "inside_transition", _6 as "elementsWrapper", _7 as "arrow", _8 as "arrow_next", _9 as "hide", _a as "arrow_prev", _b as "disabled" }
export default { "__esModule": _1, "container": _2, "slider": _3, "inside": _4, "inside_transition": _5, "elementsWrapper": _6, "arrow": _7, "arrow_next": _8, "hide": _9, "arrow_prev": _a, "disabled": _b }
